import React from 'react';

export const AnnouncementContext = React.createContext();
